import { render, staticRenderFns } from "./Gdpr.vue?vue&type=template&id=640fbb7e&scoped=true&"
import script from "./Gdpr.vue?vue&type=script&lang=js&"
export * from "./Gdpr.vue?vue&type=script&lang=js&"
import style0 from "./Gdpr.vue?vue&type=style&index=0&id=640fbb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fbb7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VContainer})
